/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */
/* eslint max-len: 0 */
import * as inputDigital from './inputDigital';

// -------- Aliases directos a generadores existentes --------
export const LGO_entradas_ultrasonidO = inputDigital.entradas_ultrasonido;
export const LGO_read_dht11 = inputDigital.SALIDAS_read_dht11;

// -------- LGO_motor_doble / _pwm --------
// El bloque se ve igual que BHOOT_motor_doble pero el generador no: usa su
// propio helper LGO_* sin rama butyV2. No aliasear a BHOOT_motor_doble.
const LGO_MOTORS_HELPER = `
const int LGO_MI = 7;
const int LGO_PWM2 = 6;
const int LGO_PWM1 = 5;
const int LGO_MD = 4;

void LGO_Retroceder(int LGO_Velocidad) {
    digitalWrite(LGO_MI, LOW);
    digitalWrite(LGO_MD, LOW);
    analogWrite(LGO_PWM1, LGO_Velocidad);
    analogWrite(LGO_PWM2, LGO_Velocidad);
}

void LGO_Avanzar(int LGO_Velocidad) {
    int invertirVel = map(LGO_Velocidad, 0, 255, 255, 0);
    digitalWrite(LGO_MI, HIGH);
    digitalWrite(LGO_MD, HIGH);
    analogWrite(LGO_PWM1, invertirVel);
    analogWrite(LGO_PWM2, invertirVel);
}

void LGO_Frenar() {
    digitalWrite(LGO_MI, LOW);
    digitalWrite(LGO_MD, LOW);
    analogWrite(LGO_PWM1, 0);
    analogWrite(LGO_PWM2, 0);
}

void LGO_GirarDerecha(int LGO_Velocidad) {
    int invertirVel = map(LGO_Velocidad, 0, 255, 255, 0);
    digitalWrite(LGO_MI, HIGH);
    digitalWrite(LGO_MD, LOW);
    analogWrite(LGO_PWM1, LGO_Velocidad);
    analogWrite(LGO_PWM2, invertirVel);
}

void LGO_GirarIzquierda(int LGO_Velocidad) {
    int invertirVel = map(LGO_Velocidad, 0, 255, 255, 0);
    digitalWrite(LGO_MI, LOW);
    digitalWrite(LGO_MD, HIGH);
    analogWrite(LGO_PWM1, invertirVel);
    analogWrite(LGO_PWM2, LGO_Velocidad);
}
`;

const LGO_MOTORS_SETUP = `
    pinMode(LGO_MI, OUTPUT);
    pinMode(LGO_PWM1, OUTPUT);
    pinMode(LGO_MD, OUTPUT);
    pinMode(LGO_PWM2, OUTPUT);
`;

const installLgoMotorsHelper = (generator) => {
  generator.definitions_.motors = LGO_MOTORS_HELPER;
  generator.setups_.setup_motors = LGO_MOTORS_SETUP;
};

const LGO_MOTOR_DOBLE_FUNCTIONS = {
  3: 'LGO_Avanzar',
  4: 'LGO_Retroceder',
  5: 'LGO_GirarDerecha',
  6: 'LGO_GirarIzquierda',
  7: 'LGO_Frenar',
};

export const LGO_motor_doble = (block, generator) => {
  installLgoMotorsHelper(generator);
  const fn = LGO_MOTOR_DOBLE_FUNCTIONS[block.getFieldValue('DIR')];
  if (!fn) return '';
  return fn === 'LGO_Frenar' ? `${fn}();\n` : `${fn}(255);\n`;
};

export const LGO_motor_doble_pwm = (block, generator) => {
  installLgoMotorsHelper(generator);
  const pwm = generator.valueToCode(block, 'PWM', generator.ORDER_ATOMIC) || '';
  const fn = LGO_MOTOR_DOBLE_FUNCTIONS[block.getFieldValue('DIR')];
  if (!fn) return '';
  return fn === 'LGO_Frenar' ? `${fn}();\n` : `${fn}(${pwm});\n`;
};

// -------- LGO_infrared: digitalRead comparado con color negro/blanco --------
// El shadow colour_bhoot_black_white emite '255, 255, 255' (blanco) o '0, 0, 0' (negro).
export const LGO_infrared = (block, generator) => {
  const rgbColor = generator.valueToCode(block, 'COLOR', generator.ORDER_ATOMIC) || 0;
  const pin = block.getFieldValue('NPIN');
  const colorValue = (rgbColor === '255, 255, 255') ? 1 : 0;
  generator.setups_[`setup_infrared_${pin}`] = `\n  pinMode(${pin}, INPUT);\n`;
  return [`digitalRead(${pin}) == ${colorValue}`, generator.ORDER_ATOMIC];
};

// -------- LGO_salidas_led_rgb: 1 NeoPixel encendido en blanco / apagado --------
export const LGO_salidas_led_rgb = (block, generator) => {
  const stat = block.getFieldValue('STAT');
  const pin = block.getFieldValue('NPIN');
  generator.definitions_['def_led_neopixel_pin'] = '#include <Adafruit_NeoPixel.h>\n';
  generator.definitions_[`def_led_neopixel_${pin}`] = `\nAdafruit_NeoPixel LEDRGB_${pin}(1, ${pin}, NEO_GRB + NEO_KHZ800);\n`;
  generator.setups_[`setup_led_neopixel_${pin}`] = `LEDRGB_${pin}.begin();\n`;
  const setColor = stat === 'HIGH'
    ? `\n  LEDRGB_${pin}.setPixelColor(0, LEDRGB_${pin}.Color(255, 255, 255));`
    : '';
  return `\n  LEDRGB_${pin}.clear();${setColor}\n  LEDRGB_${pin}.show();\n  delayMicroseconds(300);\n  `;
};

// -------- LGO_salidas_led_rgb_color: 1 NeoPixel a color arbitrario --------
export const LGO_salidas_led_rgb_color = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  generator.definitions_['def_led_neopixel_pin'] = '#include <Adafruit_NeoPixel.h>\n';
  generator.definitions_[`def_led_neopixel_${pin}`] = `\nAdafruit_NeoPixel LEDRGB_${pin}(1, ${pin}, NEO_GRB + NEO_KHZ800);\n`;
  generator.setups_[`setup_led_neopixel_${pin}`] = `LEDRGB_${pin}.begin();\n`;
  return `\n  LEDRGB_${pin}.clear();\n  LEDRGB_${pin}.setPixelColor(0, LEDRGB_${pin}.Color(${color}));\n  LEDRGB_${pin}.show();\n  delayMicroseconds(300);\n`;
};

// -------- LGO_salidas_led_rgb_pwm: 1 NeoPixel con RGB separado (R/G/B) --------
export const LGO_salidas_led_rgb_pwm = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  const r = generator.valueToCode(block, 'DATOINR', generator.ORDER_ATOMIC) || 0;
  const g = generator.valueToCode(block, 'DATOING', generator.ORDER_ATOMIC) || 0;
  const b = generator.valueToCode(block, 'DATOINB', generator.ORDER_ATOMIC) || 0;
  generator.definitions_['def_led_neopixel_pin'] = '#include <Adafruit_NeoPixel.h>\n';
  generator.definitions_[`def_led_neopixel_${pin}`] = `\nAdafruit_NeoPixel LEDRGB_${pin}(1, ${pin}, NEO_GRB + NEO_KHZ800);\n`;
  generator.setups_[`setup_led_neopixel_${pin}`] = `LEDRGB_${pin}.begin();\n`;
  return `\n  LEDRGB_${pin}.clear();\n  LEDRGB_${pin}.setPixelColor(0, LEDRGB_${pin}.Color(${r}, ${g}, ${b}));\n  LEDRGB_${pin}.show();\n  delayMicroseconds(300);\n`;
};

// -------- LGO_semaphore: 3 NeoPixels en serie (semaforo) --------
export const LGO_semaphore = (block, generator) => {
  const color1 = generator.valueToCode(block, 'COLOUR1', generator.ORDER_ATOMIC) || 0;
  const color2 = generator.valueToCode(block, 'COLOUR2', generator.ORDER_ATOMIC) || 0;
  const color3 = generator.valueToCode(block, 'COLOUR3', generator.ORDER_ATOMIC) || 0;
  const led = block.getFieldValue('NPIN') || '0';
  generator.definitions_['def_led_neopixel_pin'] = '#include <Adafruit_NeoPixel.h>\n';
  generator.definitions_[`semaphore_lgo20${led}`] = `\nAdafruit_NeoPixel SEMAFORO_${led}(3, ${led}, NEO_GRB + NEO_KHZ800);\n`;
  generator.setups_[`semaphore_lgo20${led}`] = `SEMAFORO_${led}.begin();\n`;
  return `\nSEMAFORO_${led}.clear();\nSEMAFORO_${led}.setPixelColor(0, SEMAFORO_${led}.Color(${color1}));\nSEMAFORO_${led}.setPixelColor(1, SEMAFORO_${led}.Color(${color2}));\nSEMAFORO_${led}.setPixelColor(2, SEMAFORO_${led}.Color(${color3}));\nSEMAFORO_${led}.show();\ndelayMicroseconds(300);\n`;
};

// -------- LGO_piezo_buzzer_piano: tone() sin quirk octave===3?4 --------
export const LGO_piezo_buzzer_piano = (block) => {
  const value = block.getFieldValue('PIANO');
  const pin = block.getFieldValue('NPIN') || 2;
  const pitch = (value.basePitch * value.octave) || 131;
  const duration = value.duration || 1000;
  return `\n  tone(${pin}, ${pitch}, ${duration});\n  `;
};

// -------- LGO_motor_single: pin1/pin2 con LOW/HIGH sin butyV2 quirk --------
// Usa la misma clave de setup que BHOOT_motor_single (setup_motors_single_<pin1>).
export const LGO_motor_single = (block, generator) => {
  const doublePin = block.getFieldValue('NPIN').split(',');
  const pin1 = doublePin[0];
  const pin2 = doublePin[1];
  let direccion1;
  let direccion2;
  switch (block.getFieldValue('DIR')) {
    case '3':
      direccion1 = 'LOW'; direccion2 = 'HIGH';
      break;
    case '4':
      direccion1 = 'HIGH'; direccion2 = 'LOW';
      break;
    case '6':
      direccion1 = 'LOW'; direccion2 = 'LOW';
      break;
    default: return '';
  }
  generator.setups_[`setup_motors_single_${pin1}`] = `\npinMode(${pin1}, OUTPUT);\npinMode(${pin2}, OUTPUT);\n`;
  return `\n    digitalWrite(${pin1}, ${direccion1});\n    digitalWrite(${pin2}, ${direccion2});\n`;
};

// -------- LGO_motor_single_speed: analogWrite con mapeo condicional --------
// Mapeo del legacy preservado: con pin1 '7' se invierte en dir 3 y no en 4; el
// resto de pines, al revés.
export const LGO_motor_single_speed = (block, generator) => {
  const PWM = generator.valueToCode(block, 'PWM', generator.ORDER_ATOMIC) || '';
  const doublePin = block.getFieldValue('NPIN').split(',');
  const pin1 = doublePin[0];
  const pin2 = doublePin[1];
  let code = '';
  switch (block.getFieldValue('DIR')) {
    case '3':
      code = (pin1 === '7')
        ? `\n  digitalWrite(${pin1}, HIGH);\n  analogWrite(${pin2}, map(${PWM}, 0, 255, 255, 0));\n`
        : `\n  digitalWrite(${pin1}, LOW);\n  analogWrite(${pin2}, ${PWM});\n`;
      break;
    case '4':
      code = (pin1 === '7')
        ? `\n  digitalWrite(${pin1}, LOW);\n  analogWrite(${pin2}, ${PWM});\n`
        : `\n  digitalWrite(${pin1}, HIGH);\n  analogWrite(${pin2}, map(${PWM}, 0, 255, 255, 0));\n`;
      break;
    case '6':
      code = `\n  digitalWrite(${pin1}, LOW);\n  digitalWrite(${pin2}, LOW);\n`;
      break;
    default: return '';
  }
  generator.setups_[`setup_motors_single_${pin1}`] = `\npinMode(${pin1}, OUTPUT);\npinMode(${pin2}, OUTPUT);\n`;
  return code;
};

// -------- LGO_servo_move: attach + write con angulo --------
export const LGO_servo_move = (block, generator) => {
  const angle = generator.valueToCode(block, 'angulo', generator.ORDER_ATOMIC);
  const pin = block.getFieldValue('NPIN') || '';
  generator.definitions_['include_servo'] = '#include <Servo.h>\n\n';
  generator.definitions_[`include_servo_${pin}`] = `Servo servo_${pin};\n`;
  generator.setups_[`servo_move_${pin}`] = `servo_${pin}.attach(${pin});`;
  return `servo_${pin}.write(${angle});\n`;
};

// -------- LGO_servo_move_millis: interpolacion gradual via funcion helper --------
export const LGO_servo_move_millis = (block, generator) => {
  const angle = generator.valueToCode(block, 'angulo', generator.ORDER_ATOMIC);
  const millis = generator.valueToCode(block, 'millis', generator.ORDER_ATOMIC);
  const pin = block.getFieldValue('NPIN') || '';
  generator.definitions_['include_servo'] = '#include <Servo.h>\n\n';
  generator.definitions_[`include_servo_${pin}`] = `Servo servo_${pin};\n  `;
  generator.definitions_[`include_servo_move_${pin}`] = `
void moverServoGradualmente_${pin}(int angulo, int intervalo) {
  if (servo_${pin}.read() < angulo) {
    for (int i = servo_${pin}.read(); i <= angulo; i++) {
      servo_${pin}.write(i);
      delay(intervalo);
    }
  } else {
    for (int i = servo_${pin}.read(); i >= angulo; i--) {
      servo_${pin}.write(i);
      delay(intervalo);
    }
  }
}
`;
  generator.setups_[`servo_move_${pin}`] = `servo_${pin}.attach(${pin});`;
  return `\n  moverServoGradualmente_${pin}(${angle}, ${millis});\n`;
};

// -------- LGO_servo_360: direccion 3=180 / 4=0 / 6=90 en write() --------
// Un servo continuo (360°) se controla con write(0-180) donde 90 es frenar.
export const LGO_servo_360 = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  let direccion;
  switch (block.getFieldValue('NPIN1')) {
    case '3': direccion = '180'; break;
    case '4': direccion = '0'; break;
    case '6': direccion = '90'; break;
    default: direccion = '90';
  }
  generator.definitions_['LGO_servo_360'] = '#include <Servo.h>\n';
  generator.definitions_[`LGO_servo_360_${pin}`] = `Servo servo_${pin};\n`;
  generator.setups_[`LGO_servo_360_${pin}`] = `servo_${pin}.attach(${pin});\n`;
  return `servo_${pin}.write(${direccion});\n`;
};

// -------- LGO_servo_360_pwm: direccion con velocidad via map() 0-100 --------
export const LGO_servo_360_pwm = (block, generator) => {
  const pwm = generator.valueToCode(block, 'DATOIN', generator.ORDER_ATOMIC);
  const pin = block.getFieldValue('NPIN');
  let direccion;
  switch (block.getFieldValue('NPIN1')) {
    case '3': direccion = `map(${pwm},0,100,90,180)`; break;
    case '4': direccion = `map(${pwm},0,100,90,0)`; break;
    case '6': direccion = '90'; break;
    default: direccion = '90';
  }
  generator.definitions_['LGO_servo_360'] = '#include <Servo.h>\n';
  generator.definitions_[`LGO_servo_360_${pin}`] = `Servo servo_${pin};\n`;
  generator.setups_[`LGO_servo_360_${pin}`] = `servo_${pin}.attach(${pin});\n`;
  return `servo_${pin}.write(${direccion});\n`;
};

// -------- LGO_oled: bitmap 128x64 desde el field MATRIX --------
// Nombre del bitmap derivado de block.id (no Math.random() como el legacy)
// para que el código sea reproducible y dedupe bien.
export const LGO_oled = (block, generator) => {
  const value = block.getFieldValue('MATRIX') || {};
  const frames = value.frames || [];
  const rows = 64;
  const cols = 128;
  const blkId = String(block.id || 'lgo').replace(/[^a-z0-9]/gi, '');

  generator.definitions_['LGO_oled'] = `
#include <SPI.h>
#include <Wire.h>
#include <Adafruit_GFX.h>
#include <Adafruit_SSD1306.h>

#define SCREEN_WIDTH 128
#define SCREEN_HEIGHT 64

#define OLED_RESET -1
#define SCREEN_ADDRESS 0x3C
Adafruit_SSD1306 display(OLED_RESET);
`;

  const bitmapNames = [];
  let defs = '';
  frames.forEach((frame, idx) => {
    const name = `bitmap_${blkId}_${idx}`;
    const leds = frame.leds || {};
    const bytes = [];
    for (let led = 0; led < (rows * cols); led += 8) {
      let byte = '0b';
      for (let j = 0; j < 8; j += 1) byte += leds[led + j] ? '1' : '0';
      bytes.push(byte);
    }
    bitmapNames.push({ name, duration: frame.duration });
    defs += `\nstatic const unsigned char PROGMEM ${name}[] = {\n  ${bytes.join(', ')}\n};\n`;
  });
  generator.definitions_[`LGO_oled_${block.id || 'lgo'}`] = defs;

  generator.setups_['LGO_oled'] = `
  display.begin(SSD1306_SWITCHCAPVCC, SCREEN_ADDRESS);
  display.setTextColor(WHITE);
  display.clearDisplay();
  display.display();
`;

  return bitmapNames.map((b) => `
  display.drawBitmap(0, 0, ${b.name}, SCREEN_WIDTH, SCREEN_HEIGHT, WHITE);
  display.display();
  delay(${b.duration || 1000});
  display.clearDisplay();
  display.display();
`).join('');
};

// -------- oled_text / oled_clear: pantalla SSD1306 (texto + limpieza) --------
// Usan la misma clave 'LGO_oled' para includes/setups y así dedupan con LGO_oled.

const OLED_INCLUDE = `
#include <SPI.h>
#include <Wire.h>
#include <Adafruit_GFX.h>
#include <Adafruit_SSD1306.h>

#define SCREEN_WIDTH 128
#define SCREEN_HEIGHT 64

#define OLED_RESET -1
#define SCREEN_ADDRESS 0x3C
Adafruit_SSD1306 display(OLED_RESET);
`;

const OLED_SETUP = `
  display.begin(SSD1306_SWITCHCAPVCC, SCREEN_ADDRESS);
  display.setTextColor(WHITE);
  display.clearDisplay();
  display.display();
`;

export const oled_clear = (block, generator) => {
  generator.definitions_['LGO_oled'] = OLED_INCLUDE;
  generator.setups_['LGO_oled'] = OLED_SETUP;
  return 'display.clearDisplay();\ndisplay.display();\n';
};

export const oled_text = (block, generator) => {
  const text = generator.valueToCode(block, 'NAME', generator.ORDER_ATOMIC) || 'abc';
  const posX = generator.valueToCode(block, 'POSX', generator.ORDER_ATOMIC) || '0';
  const posY = generator.valueToCode(block, 'POSY', generator.ORDER_ATOMIC) || '0';
  const size = block.getFieldValue('SIZE') || '0';
  generator.definitions_['LGO_oled'] = OLED_INCLUDE;
  generator.definitions_['LGO_oled_text'] = `
void escribirDisplay(String texto, int tam, int posx, int posy){
  display.setTextSize(tam);
  display.setCursor(posx, posy);
  display.println(texto);
  display.display();
}
`;
  generator.setups_['LGO_oled'] = OLED_SETUP;
  return `escribirDisplay(String(${text}), ${size}, ${posX}, ${posY});\n`;
};

// -------- matrix8x8lgo: matriz I2C 8x8 con bitmap desde el campo MATRIX --------
// Nombre derivado de block.id (no random como el legacy) para que sea reproducible.
export const matrix8x8lgo = (block, generator) => {
  const cols = 8;
  const rows = 8;
  const { leds } = block.getFieldValue('MATRIX') || {};
  const blkId = String(block.id || 'lgo').replace(/[^a-z0-9]/gi, '');
  const randName = `bitmap_${blkId}`;
  const randClass = 'matrix_8x8lgo';

  let byteLeds = '{';
  for (let j = 0; j < cols; j += 1) {
    byteLeds += '\n\t0b';
    for (let i = 0; i < rows; i += 1) {
      const ledIndex = (cols - 1 - i) * cols + (cols - 1 - j);
      byteLeds += (leds && leds[ledIndex]) ? '1' : '0';
    }
    byteLeds += (j < cols - 1) ? ',' : '';
  }
  byteLeds += '\n};\n';

  generator.definitions_['define_matrixlgo'] = `
#include "Freenove_VK16K33_Lib.h"
Freenove_VK16K33 ${randClass} = Freenove_VK16K33();
static byte blank[] = {0,0,0,0,0,0,0,0};
`;

  generator.definitions_[`define_matrixlgo_${block.id || 'lgo'}`] = `\nstatic uint8_t ${randName}[] = ${byteLeds}\n`;

  generator.setups_['setup_matrizlgo'] = `\n  ${randClass}.init(0x70);\n  ${randClass}.setBlink(VK16K33_BLINK_OFF);\n`;

  return `\n  ${randClass}.showStaticArray(${randName}, blank);\n`;
};

// -------- entradas_gas: analogRead (bloque analogico compartido) --------
export const entradas_gas = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  return [`analogRead(${pin})`, generator.ORDER_ATOMIC];
};
